<template>
  <subpage-shell
    :eyebrow="trans.get('landing.subpages.datenschutz.eyebrow')"
    :title-prefix="trans.get('landing.subpages.datenschutz.title_prefix')"
    :title-grad="trans.get('landing.subpages.datenschutz.title_grad')"
    :title-suffix="trans.get('landing.subpages.datenschutz.title_suffix')"
    :lede-prefix="trans.get('landing.subpages.datenschutz.lede')"
    :show-jugendschutz="true"
    :show-cta="false"
    footer-variant="legal"
  >
    <main class="prose">
      <div class="toc">
        <h4>{{ trans.get('landing.subpages.datenschutz.toc.title') }}</h4>
        <ol>
          <li>
            <a href="#verantwortlicher">{{ trans.get('landing.subpages.datenschutz.toc.i1') }}</a>
          </li>
          <li>
            <a href="#erhebung">{{ trans.get('landing.subpages.datenschutz.toc.i2') }}</a>
          </li>
          <li>
            <a href="#weitergabe">{{ trans.get('landing.subpages.datenschutz.toc.i3') }}</a>
          </li>
          <li>
            <a href="#cookies">{{ trans.get('landing.subpages.datenschutz.toc.i4') }}</a>
          </li>
          <li>
            <a href="#analyse">{{ trans.get('landing.subpages.datenschutz.toc.i5') }}</a>
          </li>
          <li>
            <a href="#plugins">{{ trans.get('landing.subpages.datenschutz.toc.i6') }}</a>
          </li>
          <li>
            <a href="#social">{{ trans.get('landing.subpages.datenschutz.toc.i7') }}</a>
          </li>
          <li>
            <a href="#newsletter">{{ trans.get('landing.subpages.datenschutz.toc.i8') }}</a>
          </li>
          <li>
            <a href="#rechte">{{ trans.get('landing.subpages.datenschutz.toc.i9') }}</a>
          </li>
          <li>
            <a href="#widerspruch">{{ trans.get('landing.subpages.datenschutz.toc.i10') }}</a>
          </li>
          <li>
            <a href="#sicherheit">{{ trans.get('landing.subpages.datenschutz.toc.i11') }}</a>
          </li>
          <li>
            <a href="#aktualitaet">{{ trans.get('landing.subpages.datenschutz.toc.i12') }}</a>
          </li>
          <li>
            <a href="#dauer">{{ trans.get('landing.subpages.datenschutz.toc.i13') }}</a>
          </li>
          <li>
            <a href="#loeschung">{{ trans.get('landing.subpages.datenschutz.toc.i14') }}</a>
          </li>
        </ol>
      </div>

      <h2 id="verantwortlicher">
        1. Angabe des verantwortlichen für die Datenverarbeitung und die des bestellten
        Datenschutzbeauftragten:
      </h2>
      <p>Extern bestellter Datenschutzbeauftragter:</p>
      <p>We2Gether GmbH<br />Friedrichstr. 171</p>
      <p>10117 Berlin</p>
      <p>
        Sollten Sie ein spezielles Anliegen haben, welches den Datenschutz dieser Webseite betrifft,
        so können Sie uns eine E-Mail schreiben unter:
      </p>
      <p><a href="mailto:datenschutz@viluu.de">datenschutz@viluu.de</a></p>

      <h2 id="erhebung">
        2. Erhebung und Speicherung von Daten, sowie personenbezogener Daten, als auch Begründung
        derer Verwendung
      </h2>
      <h3>a) Bei der Registrierung, bzw. eröffnen eines Benutzerkontos</h3>
      <p>Bei der Registrierung werden folgende Pflichtangaben erhoben und gespeichert:</p>
      <ul>
        <li>Benutzername</li>
        <li>E-Mail-Adresse</li>
        <li>Passwort (als Hash)</li>
        <li>Ihre persönlich zugeordnete IP-Adresse</li>
        <li>Landesherkunft der zugeordnete IP-Adresse</li>
        <li>Geschlecht</li>
        <li>Wohnanschrift</li>
        <li>Registrierdatum</li>
      </ul>
      <h3>b) Beim Besuch auf <a href="https://www.viluu.de">www.viluu.de</a></h3>
      <p>
        Beim Aufrufen, bzw. Besuchen auf <a href="https://www.viluu.de">www.viluu.de</a> können Sie
        Ihr Profil ergänzen. Diese Daten können als Formular ausgefüllt werden und sind freiwillig.
        Alle ergänzenden Daten, die Sie ausfüllen werden von uns gespeichert und sind Teil Ihres
        persönlichen Profiles. Beim Aufrufen, bzw. Besuchen auf
        <a href="https://www.viluu.de">www.viluu.de</a> werden durch den Browsers Ihres Endgerätes
        automatisch Daten an unseren Server gesendet, welche Sie nicht unterbinden können:
      </p>
      <ul>
        <li>Ihre persönlich zugeordnete IP-Adresse</li>
        <li>Datum und Uhrzeit des Zugriffes</li>
        <li>Name und URL der abgerufenen Datei</li>
        <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
        <li>verwendeter Browser inkl. Engine und verwendeter Plugins</li>
        <li>Bildschirmauflösung</li>
        <li>verwendetes Betriebssystem Ihres Rechners</li>
        <li>Name Ihres internet-Service-Providers.</li>
      </ul>
      <h3>c) Zweck und Begründung der notwendigen Datenergebung</h3>
      <p>
        Die genannten Datenergebungen laut lit. a und b werden zu folgenden Zwecken verarbeitet:
      </p>
      <ul>
        <li>zur eindeutigen Identifizierung und Differenzierung der Benutzer</li>
        <li>zur Bestimmung des Alters</li>
        <li>zur Ermittlung eines geeigneten Flirtpartners</li>
        <li>zur Eingliederung in unseren Suchalgorithmus</li>
        <li>
          zur Nachvollziehbatkeit von Fehler und ggf. dessen anschließender Supportbearbeitung
        </li>
        <li>zur Sicherstellung der korrekten Bedienung des Angebotes</li>
        <li>zur Datenanalyse in Bezug auf Sicherheit und Stabilität der Server</li>
        <li>zur einfacheren Durchführung allgemeiner administrativer Tätigkeiten</li>
      </ul>
      <p>
        Die Rechtsgrundlage für diese Datenverarbeitung ist in Art. 6 Abs. 1 S. 1 lit. f DSGVO
        nachzulesen. Unser berechtigtes Interesse folgt aus oben aufgelisteten Zwecken zur
        Datenerhebung. In keinem Fall verwenden wir die erhobenen Daten zu dem Zweck, Rückschlüsse
        auf Ihre Person zu ziehen. Darüber hinaus setzen wir beim Besuch unserer Website Cookies
        sowie Analysedienste ein. Nähere Erläuterungen dazu erhalten Sie unter den Ziff. 4 und 5
        dieser Datenschutzerklärung.
      </p>
      <h3>d) Bei Nutzung unserer Kontaktformulare</h3>
      <p>
        Sie haben die Möglichkeit über die zur Verfügung gestellten Kontaktformulare mit uns Kontakt
        aufzunehmen. Diese Möglichkeit besteht auch, wenn Sie bei uns kein Benutzerkonto haben.
        Beispielsweise wenn Sie ein bestimmten Anliegen haben oder bei einem Problem weitere Hilfe
        benötigen. Dabei ist die Angabe von Name, einer gültigen E-Mail-Adresse und der
        Nachrichtentext erforderlich. Nur so können wir Ihnen bei bedarf helfen und mit Ihnen wieder
        Kontakt aufnehmen. Die Datenverarbeitung zum Zwecke der Kontaktaufnahme mit uns erfolgt nach
        Art. 6 Abs. 1 S. 1 lit. a DSGVO. Die für die Benutzung des Kontaktformulars von uns
        erhobenen personenbezogenen Daten werden zwecks Qualitätskontrolle und Mitarbeiterschulungen
        solange gespeichert, bis Sie Widerruf einlegen und um die Löschung Ihrer Daten bitten.
      </p>

      <h2 id="weitergabe">3. Weitergabe von Daten</h2>
      <p>
        Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden
        aufgeführten Zwecken findet nicht statt. Wir geben Ihre persönlichen Daten nur an Dritte
        weiter, wenn:
      </p>
      <ul>
        <li>
          Sie Ihre nach Art. 6 Abs. 1 S. 1 lit. a DSGVO ausdrückliche Einwilligung dazu erteilt
          haben
        </li>
        <li>
          die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur Vertragserfüllung erforderlich ist
          und kein Grund zur Annahme besteht, dass Sie ein überwiegendes schutzwürdiges Interesse an
          der Nichtweitergabe Ihrer Daten haben
        </li>
        <li>
          für den Fall, dass für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c DSGVO eine
          gesetzliche Verpflichtung besteht
        </li>
        <li>
          sowie dies gesetzlich zulässig und nach Art. 6 Abs. 1 S. 1 lit. B DSGVO für die Abwicklung
          von Vertragsverhältnissen mit Ihnen erforderlich ist.
        </li>
      </ul>
      <p>
        Bei Tätigung von Bezahlvorgängen auf unserer Webseite und die dadurch verbundene Verwendung
        von den verschiedenen Zahlungsdienstleister gilt folgendes:
      </p>
      <p><strong>Paypal</strong></p>
      <p>
        Bei Zahlung via PayPal, Kreditkarte via PayPal, Lastschrift via PayPal oder – falls
        angeboten - "Kauf auf Rechnung" oder „Ratenzahlung" via PayPal geben wir Ihre Zahlungsdaten
        im Rahmen der Zahlungsabwicklung an die PayPal (Europe) S.a.r.l. et Cie, S.C.A., 22-24
        Boulevard Royal, L-2449 Luxembourg (nachfolgend "PayPal"), weiter. Die Weitergabe erfolgt
        gemäß Art. 6 Abs. 1 lit. b DSGVO und nur insoweit, als dies für die Zahlungsabwicklung
        erforderlich ist. PayPal behält sich für die Zahlungsmethoden Kreditkarte via PayPal,
        Lastschrift via PayPal oder – falls angeboten - "Kauf auf Rechnung" oder „Ratenzahlung" via
        PayPal die Durchführung einer Bonitätsauskunft vor. Hierfür werden Ihre Zahlungsdaten
        gegebenenfalls gemäß Art. 6 Abs. 1 lit. f DSGVO auf Basis des berechtigten Interesses von
        PayPal an der Feststellung Ihrer Zahlungsfähigkeit an Auskunfteien weitergegeben. Das
        Ergebnis der Bonitätsprüfung in Bezug auf die statistische Zahlungsausfallwahrscheinlichkeit
        verwendet PayPal zum Zwecke der Entscheidung über die Bereitstellung der jeweiligen
        Zahlungsmethode. Die Bonitätsauskunft kann Wahrscheinlichkeitswerte enthalten (sog.
        Score-Werte). Soweit Score-Werte in das Ergebnis der Bonitätsauskunft einfließen, haben
        diese ihre Grundlage in einem wissenschaftlich anerkannten mathematisch-statistischen
        Verfahren. In die Berechnung der Score-Werte fließen unter anderem, aber nicht
        ausschließlich, Anschriftendaten ein. Weitere datenschutzrechtliche Informationen, unter
        anderem zu den verwendeten Auskunfteien, entnehmen Sie bitte der Datenschutzerklärung von
        PayPal:
        <a href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full">Datenschutzerklärung</a>.
        Sie können dieser Verarbeitung Ihrer Daten jederzeit durch eine Nachricht an PayPal
        widersprechen. Jedoch bleibt PayPal ggf. weiterhin berechtigt, Ihre personenbezogenen Daten
        zu verarbeiten, sofern dies zur vertragsgemäßen Zahlungsabwicklung erforderlich ist.
      </p>
      <p><strong>SOFORT</strong></p>
      <p>
        Bei Auswahl der Zahlungsart „SOFORT" erfolgt die Zahlungsabwicklung über den
        Zahlungsdienstleister SOFORT GmbH; Theresienhöhe 12; 80339 München; Deutschland -(im
        Folgenden „SOFORT")-, an den wir Ihre im Rahmen des Bestellvorgangs mitgeteilten
        Informationen nebst den Informationen über Ihre Bestellung gemäß Art. 6 Abs. 1 lit. b DSGVO
        weitergeben. Die Sofort GmbH ist Teil der Klarna Group (Klarna Bank AB (publ), Sveavägen 46,
        11134 Stockholm, Schweden). Die Weitergabe Ihrer Daten erfolgt ausschließlich zum Zwecke der
        Zahlungsabwicklung mit dem Zahlungsdienstleister SOFORT und nur insoweit, als sie hierfür
        erforderlich ist. Unter der nachstehenden Internetadresse erhalten Sie weitere Informationen
        über die Datenschutzbestimmungen von SOFORT:
        <a href="https://www.klarna.com/sofort/datenschutz">Datenschutzbestimmungen</a>.
      </p>
      <p><strong>Paysafe, MobilePay, Call2Pay</strong></p>
      <p>
        Bei Auswahl der Zahlungsart „Paysafe", „MobilePay", „Call2Pay" erfolgt die
        Zahlungsabwicklung über den Zahlungsdienstleister micropayment GmbH; Scharnweberstrasse 69;
        12587 Berlin; Deutschland, an den wir Ihre im Rahmen des Bestellvorgangs mitgeteilten
        Informationen nebst den Informationen über Ihre Bestellung gemäß Art. 6 Abs. 1 lit. b DSGVO
        weitergeben. Die Weitergabe Ihrer Daten erfolgt ausschließlich zum Zwecke der
        Zahlungsabwicklung mit dem Zahlungsdienstleister micropayment und nur insoweit, als sie
        hierfür erforderlich ist. Unter der nachstehenden Internetadresse erhalten Sie weitere
        Informationen über die Datenschutzbestimmungen von der micropayment GmbH:
        <a href="https://www.micropayment.de/about/privacy/?_r=gst&amp;_src=ctor"
          >Datenschutzbestimmungen</a
        >.
      </p>
      <p><strong>Bezahlen mit Kreditkarte (Mastercard, VISA)</strong></p>
      <p>
        Bei Auswahl der Zahlungsart „Mastercard / VISA" erfolgt die Zahlungsabwicklung über den
        Zahlungsdienstleister Stripe; 185 Berry Street, Suite 550; San Francisco, CA 94107;
        Vereinigte Staaten von Amerika, an den wir Ihre im Rahmen des Bestellvorgangs mitgeteilten
        Informationen nebst den Informationen über Ihre Bestellung gemäß Art. 6 Abs. 1 lit. b DSGVO
        weitergeben. Die Weitergabe Ihrer Daten erfolgt ausschließlich zum Zwecke der
        Zahlungsabwicklung mit dem Zahlungsdienstleister Stripe und nur insoweit, als sie hierfür
        erforderlich ist. Unter der nachstehenden Internetadresse erhalten Sie weitere Informationen
        über die Datenschutzbestimmungen von Stripe:
        <a href="https://stripe.com/de/privacy">Datenschutzbestimmungen</a>.
      </p>

      <h2 id="cookies">4. Cookies</h2>
      <p>
        Um den reibungslosen Besuch unserer Website zu gewährleisten und die Nutzung bestimmter
        Funktionen zu vereinfachen, verwenden wir Cookies. Hierbei handelt es sich um kleine
        Textdateien, welche bestimmte - von uns generierte - Informationen enthalten, welche von
        Ihrem Browser auf Ihrem Endgerät abgelegt werden. Diese Informationen können von Ihrem
        Browser wieder gelesen und an uns wieder Übertragen werden. Einige der von uns verwendeten
        Cookies werden nach dem Ende der Browser-Sitzung, also nach Schließen Ihres Browsers, wieder
        gelöscht (Sitzungs-Cookies oder Session-Cookies). Andere Cookies verbleiben auf Ihrem
        Endgerät und ermöglichen uns Ihren Browser beim nächsten Besuch wiederzuerkennen
        (persistente Cookies). Cookies dienen und dazu, durch Speicherung von Einstellungen Ihnen
        den natürlichen Ablauf und die Bewegung auf unserer Webseite zu vereinfachen. Dazu gehören
        beispielsweise das speichern Ihrer Suchparameter in der Benutzersuche und müssen nicht
        jedesmal erneut von Ihnen eingegeben werden. Sofern durch einzelne von uns implementierte
        Cookies auch personenbezogene Daten verarbeitet werden, erfolgt die Verarbeitung gemäß Art.
        6 Abs. 1 lit. b DSGVO entweder zur Durchführung des Vertrages oder gemäß Art. 6 Abs. 1 lit.
        f DSGVO zur Wahrung unserer berechtigten Interessen an der bestmöglichen Funktionalität der
        Website sowie einer kundenfreundlichen und effektiven Ausgestaltung des Seitenbesuchs. Ihr
        Browser kann so einstellen können, dass Sie über das Setzen von Cookies informiert werden
        und einzeln über deren Annahme entscheiden oder die Annahme von Cookies für bestimmte Fälle
        oder generell ausschließen können. Jeder Browser unterscheidet sich in der Art, wie er die
        Cookie-Einstellungen verwaltet. Diese ist in dem Hilfemenü jedes Browsers beschrieben,
        welches Ihnen erläutert, wie Sie Ihre Cookie-Einstellungen ändern können. Diese finden Sie
        für die jeweiligen Browser unter den folgenden Links:
      </p>
      <ul>
        <li>
          Internet Explorer:
          <a href="http://windows.microsoft.com/de-DE/windows-vista/Block-or-allow-cookies"
            >Cookiebestimmungen</a
          >
        </li>
        <li>
          Firefox:
          <a href="https://support.mozilla.org/de/kb/cookies-erlauben-und-ablehnen"
            >Cookiebestimmungen</a
          >
        </li>
        <li>
          Chrome:
          <a
            href="https://support.google.com/chrome/bin/answer.py?hl=de&amp;hlrm=en&amp;answer=95647"
            >Cookiebestimmungen</a
          >
        </li>
        <li>
          Safari: <a href="https://support.apple.com/kb/ph21411?locale=de_DE">Cookiebestimmungen</a>
        </li>
        <li>
          Opera:
          <a href="http://help.opera.com/Windows/10.20/de/cookies.html">Cookiebestimmungen</a>
        </li>
      </ul>

      <h2 id="analyse">5. Analyse-Tools</h2>
      <h3>a) Tracking-Tools im Allgemeinen</h3>
      <p>
        Die im Folgenden aufgeführten und von uns eingesetzten Tracking-Maßnahmen werden auf
        Grundlage des Art. 6 Abs. 1 S. 1 lit. f DSGVO durchgeführt. Mit den zum Einsatz kommenden
        Tracking-Maßnahmen wollen wir eine bedarfsgerechte Gestaltung und die fortlaufende
        Optimierung unserer Webseite sicherstellen. Zum anderen setzen wir die Tracking-Maßnahmen
        ein, um die Nutzung unserer Webseite statistisch zu erfassen und zum Zwecke der Optimierung
        unseres Angebotes für Sie auszuwerten. Diese Interessen sind als berechtigt im Sinne der
        vorgenannten Vorschrift anzusehen. Die jeweiligen Datenverarbeitungszwecke und
        Datenkategorien sind aus den entsprechenden Tracking-Tools zu entnehmen.
      </p>
      <h3>b) Google Analytics</h3>
      <p>
        Zum Zwecke der bedarfsgerechten Gestaltung und fortlaufenden Optimierung unserer Seiten
        nutzen wir Google Analytics, ein Webanalysedienst der Google Inc. (<a
          href="https://www.google.de/intl/de/about/"
          >Google Analytics</a
        >) (1600 Amphitheatre Parkway, Mountain View, CA 94043, USA; im Folgenden „Google"). In
        diesem Zusammenhang werden pseudonymisierte Nutzungsprofile erstellt und Cookies (siehe
        unter Ziff. 4) verwendet. Die durch den Cookie erzeugten Informationen über Ihre Benutzung
        dieser Website wie:
      </p>
      <ul>
        <li>Browser-Typ/-Version,</li>
        <li>Verwendetes Betriebssystem,</li>
        <li>Referrer-URL (die zuvor besuchte Seite),</li>
        <li>Hostname des zugreifenden Rechners (IP-Adresse),</li>
        <li>Uhrzeit der Serveranfrage,</li>
      </ul>
      <p>
        werden an einen Server von Google in den USA übertragen und dort gespeichert. Die
        Informationen werden verwendet, um die Nutzung der Website auszuwerten, um Reports über die
        Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der
        Internetnutzung verbundene Dienstleistungen zu Zwecken der Marktforschung und
        bedarfsgerechten Gestaltung dieser Internetseiten zu erbringen. Auch werden diese
        Informationen gegebenenfalls an Dritte übertragen, sofern dies gesetzlich vorgeschrieben ist
        oder soweit Dritte diese Daten im Auftrag verarbeiten. Es wird in keinem Fall Ihre
        IP-Adresse mit anderen Daten von Google zusammengeführt. Die IP-Adressen werden
        anonymisiert, so dass eine Zuordnung nicht möglich ist (IP-Masking). Sie können die
        Installation der Cookies durch eine entsprechende Einstellung der Browser-Software
        verhindern; wir weisen jedoch darauf hin, dass in diesem Fall gegebenenfalls nicht sämtliche
        Funktionen dieser Website vollumfänglich genutzt werden können. Sie können darüber hinaus
        die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen
        Daten (inkl. Ihrer IP-Adresse) sowie die Verarbeitung dieser Daten durch Google verhindern,
        indem Sie ein Browser-Add-on
        <a href="https://tools.google.com/dlpage/gaoptout?hl=de">herunterladen</a> und installieren.
        Alternativ zum Browser-Add-on, insbesondere bei Browsern auf mobilen Endgeräten, können Sie
        die Erfassung durch Google Analytics zudem verhindern, indem Sie auf diesen Link klicken. Es
        wird ein Opt-out-Cookie gesetzt, das die zukünftige Erfassung Ihrer Daten beim Besuch dieser
        Website verhindert. Der Opt-out-Cookie gilt nur in diesem Browser und nur für unsere Website
        und wird auf Ihrem Gerät abgelegt. Löschen Sie die Cookies in diesem Browser, müssen Sie das
        Opt-out-Cookie erneut setzen. Weitere Informationen zum Datenschutz im Zusammenhang mit
        Google Analytics finden Sie etwa in der
        <a href="https://support.google.com/analytics/answer/6004245?hl=de"
          >Google Analytics-Hilfe</a
        >.
      </p>
      <p>
        Wir haben mit Google einen Vertrag zur Auftragsdatenverarbeitung abgeschlossen und setzen
        die strengen Vorgaben der deutschen Datenschutzbehörden bei der Nutzung von Google Analytics
        vollständig um.
      </p>

      <h2 id="plugins">6. Plugins und Tools</h2>
      <h3>a) Google Web Fonts</h3>
      <p>
        Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so genannte Web Fonts, die
        von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten
        Web Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.
      </p>
      <p>
        Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google
        aufnehmen. Hierdurch erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse unsere
        Website aufgerufen wurde. Die Nutzung von Google Web Fonts erfolgt im Interesse einer
        einheitlichen und ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein
        berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.
      </p>
      <p>
        Wenn Ihr Browser Web Fonts nicht unterstützt, wird eine Standardschrift von Ihrem Computer
        genutzt.
      </p>
      <p>
        Weitere Informationen zu Google Web Fonts finden Sie unter
        <a href="https://developers.google.com/fonts/faq">Fonts</a> und in der Datenschutzerklärung
        von Google: <a href="https://www.google.com/policies/privacy/">Datenschutzerklärung</a>.
      </p>
      <h3>b) Google Maps</h3>
      <p>
        Diese Seite nutzt über eine API den Kartendienst Google Maps. Anbieter ist die Google Inc.,
        1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.
      </p>
      <p>
        Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP Adresse zu speichern.
        Diese Informationen werden in der Regel an einen Server von Google in den USA übertragen und
        dort gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese Datenübertragung.
      </p>
      <p>
        Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer
        Online-Angebote und an einer leichten Auffindbarkeit der von uns auf der Website angegebenen
        Orte. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.
      </p>
      <p>
        Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von
        Google: <a href="https://www.google.de/intl/de/policies/privacy/">Datenschutzerklärung</a>.
      </p>

      <h2 id="social">7. Social Media Plug-ins</h2>
      <p>
        Wir setzen auf unserer Website auf Grundlage des Art. 6 Abs. 1 S. 1 lit. f DSGVO Social
        Plug-ins der sozialen Netzwerke Facebook und Xing ein, um unser Unternehmen hierüber
        bekannter zu machen. Der dahinterstehende werbliche Zweck ist als berechtigtes Interesse im
        Sinne der DSGVO anzusehen. Die Verantwortung für den datenschutzkonformen Betrieb ist durch
        deren jeweiligen Anbieter zu gewährleisten.
      </p>
      <p><strong>Facebook Plugin</strong></p>
      <p>
        Auf unserer Website kommen Social-Media Plugins von Facebook zum Einsatz, um deren Nutzung
        persönlicher zu gestalten. Hierfür nutzen wir den Facebook-Button zur Weiterleitung auf
        unser Facebook auftritt. Es handelt sich dabei um ein Angebot von Facebook. Wenn Sie eine
        Seite unseres Webauftritts aufrufen, die ein solches Plugin enthält, baut Ihr Browser eine
        direkte Verbindung mit den Servern von Facebook auf. Der Inhalt des Plugins wird von
        Facebook direkt an Ihren Browser übermittelt und von diesem in die Webseite eingebunden.
        Durch die Einbindung der Plugins erhält Facebook die Information, dass Ihr Browser die
        entsprechende Seite unseres Webauftritts aufgerufen hat, auch wenn Sie kein Facebook-Konto
        besitzen oder gerade nicht bei Facebook eingeloggt sind. Diese Information (einschließlich
        Ihrer IP-Adresse) wird von Ihrem Browser direkt an einen Server von Facebook in den USA
        übermittelt und dort gespeichert. Sind Sie bei Facebook eingeloggt, kann Facebook den Besuch
        unserer Website Ihrem Facebook-Konto direkt zuordnen. Wenn Sie mit den Plugins interagieren,
        wird die entsprechende Information ebenfalls direkt an einen Server von Facebook übermittelt
        und dort gespeichert. Wenn Sie nicht möchten, dass Facebook die über unseren Webauftritt
        gesammelten Daten Ihrem Facebook-Konto zuordnet, müssen Sie sich vor Ihrem Besuch unserer
        Website bei Facebook ausloggen. Zweck und Umfang der Datenerhebung und die weitere
        Verarbeitung und Nutzung der Daten durch Facebook sowie Ihre diesbezüglichen Rechte und
        Einstellungsmöglichkeiten zum Schutz Ihrer Privatsphäre entnehmen Sie bitte den
        <a href="https://www.facebook.com/about/privacy/">Datenschutzhinweisen von Facebook</a>.
      </p>
      <p><strong>Twitter</strong></p>
      <p>
        Auf unseren Seiten sind Funktionen des Dienstes Twitter eingebunden. Diese Funktionen werden
        angeboten durch die Twitter Inc., 1355 Market Street, Suite 900, San Francisco, CA 94103,
        USA. Durch das Benutzen von Twitter und der Funktion "Re-Tweet" werden die von Ihnen
        besuchten Websites mit Ihrem Twitter-Account verknüpft und anderen Nutzern bekannt gegeben.
        Dabei werden auch Daten an Twitter übertragen. Wir weisen darauf hin, dass wir als Anbieter
        der Seiten keine Kenntnis vom Inhalt der übermittelten Daten sowie deren Nutzung durch
        Twitter erhalten. Ihre Datenschutzeinstellungen bei Twitter können Sie in den
        Konto-Einstellungen unter:
        <a href="https://twitter.com/account/settings">Einstellungen</a> ändern.
      </p>

      <h2 id="newsletter">8. Newsletter</h2>
      <p>Unser Newsletter informiert dich über spannende Profil-Highlights.</p>
      <p>
        Mit den nachfolgenden Hinweisen klären wir Sie über die Inhalte unseres Newsletters sowie
        das Anmelde-, Versand- und das statistische Auswertungsverfahren sowie Ihre
        Widerspruchsrechte auf. Indem Sie unseren Newsletter abonnieren, erklären Sie sich mit dem
        Empfang und den beschriebenen Verfahren einverstanden.
      </p>
      <p>
        Wir versenden Newsletter, E-Mails und weitere elektronische Benachrichtigungen mit
        werblichen Informationen (nachfolgend „Newsletter") nur mit der Einwilligung der Empfänger
        oder einer gesetzlichen Erlaubnis. Sofern im Rahmen einer Anmeldung zum Newsletter dessen
        Inhalte konkret umschrieben werden, sind sie für die Einwilligung der Nutzer maßgeblich.
      </p>
      <p>
        Die Anmeldung zu unserem Newsletter erfolgt in einem sog. Double-Opt-In-Verfahren. D.h. Sie
        erhalten nach der Anmeldung eine E-Mail, in der Sie um die Bestätigung Ihrer Anmeldung
        gebeten werden. Diese Bestätigung ist notwendig, damit sich niemand mit fremden
        E-Mailadressen anmelden kann.
      </p>
      <p>
        Die Anmeldungen zum Newsletter werden protokolliert, um den Anmeldeprozess entsprechend den
        rechtlichen Anforderungen nachweisen zu können. Hierzu gehört die Speicherung des Anmelde-
        und des Bestätigungszeitpunkts, als auch der IP-Adresse.
      </p>
      <p>
        Um sich für den Newsletter anzumelden, reicht es aus, wenn Sie Ihre E-Mailadresse angeben.
        Optional bitten wir Sie Ihren Vor- und Nachnamen anzugeben. Diese Angaben dienen lediglich
        der Personalisierung des Newsletters.
      </p>
      <p><strong>Kündigung, bzw. Widerruf des Newsletterversandes</strong></p>
      <p>
        Sie können den Empfang unseres Newsletters jederzeit kündigen, d.h. Ihre Einwilligungen
        widerrufen. Damit erlöschen gleichzeitig Ihre Einwilligungen in dessen Versand.
      </p>
      <p>Einen Link zur Kündigung des Newsletters finden Sie am Ende eines jeden Newsletters.</p>
      <p><strong>Rechtsgrundlagen Datenschutzgrundverordnung</strong></p>
      <p>
        Entsprechend den Vorgaben der ab dem 25. Mai 2018 geltenden Datenschutzgrundverordnung
        (DSGVO) informieren wir Sie, dass die Einwilligungen in den Versand der E-Mailadressen auf
        Grundlage der Art. 6 Abs. 1 lit. a, 7 DSGVO sowie § 7 Abs. 2 Nr. 3, bzw. Abs. 3 UWG erfolgt.
        Der Einsatz des Newsletter-Tools Mailpoet, Durchführung der statistischen Erhebungen und
        Analysen sowie Protokollierung des Anmeldeverfahrens, erfolgen auf Grundlage unserer
        berechtigten Interessen gem. Art. 6 Abs. 1 lit. f DSGVO. Unser Interesse richtet sich auf
        den Einsatz eines nutzerfreundlichen sowie sicheren Newslettersystems, das sowohl unseren
        gemeindlichen Interessen dient, als auch den Erwartungen der Nutzer entspricht.
      </p>
      <p>
        Wir weisen Sie ferner darauf hin, dass Sie der künftigen Verarbeitung Ihrer
        personenbezogenen Daten entsprechend den gesetzlichen Vorgaben gem. Art. 21 DSGVO jederzeit
        widersprechen können. Der Widerspruch kann insbesondere gegen die Verarbeitung für Zwecke
        der Direktwerbung erfolgen.
      </p>

      <h2 id="rechte">9. Betroffenenrechte</h2>
      <p>
        Als Eigentümer Ihrer herausgegebenen Daten räumt die DSGO Ihnen gewisse Rechte ein, von
        denen Sie Gebrauch machen können.
      </p>
      <p>Sie haben das Recht:</p>
      <p><strong>gemäß Art. 15 DSGVO</strong></p>
      <p>
        Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen. Insbesondere
        können Sie Auskunft über die Verarbeitungszwecke, die Kategorie der personenbezogenen Daten,
        die Kategorien von Empfängern, gegenüber denen Ihre Daten offengelegt wurden oder werden,
        die geplante Speicherdauer, das Bestehen eines Rechts auf Berichtigung, Löschung,
        Einschränkung der Verarbeitung oder Widerspruch, das Bestehen eines Beschwerderechts, die
        Herkunft ihrer Daten, sofern diese nicht bei uns erhoben wurden, sowie über das Bestehen
        einer automatisierten Entscheidungsfindung einschließlich Profiling und ggf.
        aussagekräftigen Informationen zu deren Einzelheiten verlangen.
      </p>
      <p><strong>gemäß Art. 16 DSGVO</strong></p>
      <p>
        auf unverzügliche Berichtigung Sie betreffender unrichtiger Daten, soewie die
        Vervollständigung Ihrer bei uns gespeicherten unvollständigen Daten.
      </p>
      <p><strong>gemäß Art. 17 DSGVO</strong></p>
      <p>
        die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen, soweit nicht
        die Verarbeitung zur Ausübung des Rechts auf freie Meinungsäußerung und Information, zur
        Erfüllung einer rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur
        Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist.
      </p>
      <p><strong>gemäß Art. 18 DSGVO</strong></p>
      <p>
        die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen, soweit die
        Richtigkeit der Daten von Ihnen bestritten wird, die Verarbeitung unrechtmäßig ist, Sie aber
        deren Löschung ablehnen und wir die Daten nicht mehr benötigen, Sie jedoch diese zur
        Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß
        Art. 21 DSGVO Widerspruch gegen die Verarbeitung eingelegt haben.
      </p>
      <p><strong>gemäß Art. 20 DSGVO</strong></p>
      <p>
        Ihre personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten,
        gängigen und maschinenlesebaren Format zu erhalten oder die Übermittlung an einen anderen
        Verantwortlichen zu verlangen.
      </p>
      <p><strong>gemäß Art. 7 Abs. 3 DSGVO</strong></p>
      <p>
        Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen. Dies hat zur Folge,
        dass wir die Datenverarbeitung, die auf dieser Einwilligung beruhte, für die Zukunft nicht
        mehr fortführen dürfen.
      </p>
      <p><strong>gemäß Art. 77 DSGVO</strong></p>
      <p>
        sich bei einer Aufsichtsbehörde zu beschweren. In der Regel können Sie sich hierfür an die
        Aufsichtsbehörde Ihres üblichen Aufenthaltsortes oder Arbeitsplatzes oder unseres
        Unternehmensstandortes wenden.
      </p>
      <p>
        Eine Liste der Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem Link
        entnommen werden:
        <a href="https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html"
          >Liste der Datenschutzbeauftragten</a
        >.
      </p>

      <h2 id="widerspruch">10. Widerspruchsrecht</h2>
      <p>
        Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6
        Abs. 1 S. 1 lit. f DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO
        Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten einzulegen, soweit dafür
        Gründe vorliegen, die sich aus Ihrer besonderen Situation ergeben oder sich der Widerspruch
        gegen Direktwerbung richtet. Im letzteren Fall haben Sie ein generelles Widerspruchsrecht,
        das ohne Angabe einer besonderen Situation von uns umgesetzt wird. Möchten Sie von Ihrem
        Widerrufs- oder Widerspruchsrecht Gebrauch machen, genügt eine E-Mail an:
        <a href="mailto:datenschutz@viluu.de">datenschutz@viluu.de</a>.
      </p>

      <h2 id="sicherheit">11. Datensicherheit</h2>
      <p>
        Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket
        Layer) in Verbindung mit der jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser
        unterstützt wird. In der Regel handelt es sich dabei um eine 256 Bit Verschlüsselung. Falls
        Ihr Browser keine 256-Bit Verschlüsselung unterstützt, greifen wir stattdessen auf 128-Bit
        v3 Technologie zurück. Ob eine einzelne Seite unseres Internetauftrittes verschlüsselt
        übertragen wird, erkennen Sie an der geschlossenen Darstellung des Schüssel- beziehungsweise
        Schloss-Symbols in der unteren Statusleiste Ihres Browsers. Wir bedienen uns im Übrigen
        geeigneter technischer und organisatorischer Sicherheitsmaßnahmen, um Ihre Daten gegen
        zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust,
        Zerstörung oder gegen den unbefugten Zugriff Dritter zu schützen. Unsere
        Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend
        verbessert.
      </p>

      <h2 id="aktualitaet">12. Aktualität und Änderung dieser Datenschutzerklärung</h2>
      <p>
        Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Mai 2018. Durch die
        Weiterentwicklung unserer Website und Angebote darüber oder aufgrund geänderter gesetzlicher
        beziehungsweise behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung
        zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf der Website
        <a href="/datenschutz">Datenschutzerklärung</a> von Ihnen abgerufen und ausgedruckt werden.
      </p>

      <h2 id="dauer">13. Dauer der Speicherung</h2>
      <p>
        Die Dauer der Speicherung von personenbezogenen Daten bemisst sich anhand der jeweiligen
        gesetzlichen Aufbewahrungsfrist (z.B. handels- und steuerrechtliche Aufbewahrungsfristen).
        Dies können beispielsweise Daten zu Bezahlvorgängen sein, die in unserem Unternehmen zur
        Nachvollziehbarkeit und Nachweisbarkeit von daraus resultierenden Steuerdaten betreffen
        könnten. Sollten Sie Widerspruch eingelegt haben, bzw. das Löschen Ihrer Daten verlangt
        haben, werden diese Daten anonymisiert und können mit Ihnen als Person nicht mehr in
        Verbindung gebracht werden. Nach Ablauf der Frist werden die entsprechenden Daten
        routinemäßig gelöscht, sofern sie nicht mehr zur Vertragserfüllung oder Vertragsanbahnung
        erforderlich sind und/oder unsererseits kein berechtigtes Interesse an der Weiterspeicherung
        fortbesteht.
      </p>

      <h2 id="loeschung">14. Löschung personenbezogener Daten</h2>
      <p>
        Um die zu Ihrer Person gespeicherten Daten zu löschen, wenden Sie sich bitte an den Support.
        Nutzen Sie das das Support-Center auf dem Portal, oder das Kontaktformular.
      </p>

      <p class="ds-end">Ende der Datenschutzerklärung</p>
    </main>
  </subpage-shell>
</template>

<script>
import SubpageShell from './SubpageShell.vue';

export default {
  name: 'DatenschutzPage',
  components: { SubpageShell },
};
</script>
